import { FaPenAlt, FaCheckCircle, FaTimesCircle } from 'react-icons/fa'
import { DatatableWrapper, Filter, Pagination, PaginationOptions, EmptyTablePlaceholder, TableBody, TableHeader } from 'react-bs-datatable'
import { Col, Row, Table } from 'react-bootstrap'

const ViewLicenses = ({
  data,
  editHandler,
}) => {

  const headers = [
    { title: 'Nombre', prop: 'name', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Tipo', prop: 'type', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Activo', prop: 'active', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Acciones', prop: '', alignment: { horizontal: 'center' } }
  ];

  return (
    <div className='table-responsive bg-light p-3 mt-2'>
      <div className='d-flex align-items-center flex-column mb-2'>
        <h3 className='fw-light text-muted'>
          Listado de licencias
        </h3>
        <button
          className='btn btn-outline-primary btn-sm shadow my-2'
          data-bs-toggle='modal'
          data-bs-target='#licenseModal'
        >
          Agregar una Licencia
        </button>
      </div>


      {data != undefined ? (

        <DatatableWrapper body={data.data} headers={headers} paginationOptionsProps={{
          initialState: {
            rowsPerPage: 15,
            options: [5, 10, 15, 20]
          }
        }} >
          <Row className="mb-4">
            <Col
              xs={12}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Filter placeholder={'Ingrese información a encontrar'} />
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
            >
              <PaginationOptions labels={{ beforeSelect: `Filas por página ` }} />
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Pagination labels={{ firstPage: 'Inicio', lastPage: 'Final', nextPage: 'Siguiente', prevPage: 'Anterior' }} />
            </Col>
          </Row>
          <hr></hr>
          <Table>
            <TableHeader />
            <TableBody>
              {(rows) =>
                rows.length === 0 ? (
                  <EmptyTablePlaceholder noResultsLabel={'Regitros no encontrados'} />
                ) : (
                  rows.map((rowData, rowIdx) => (
                    <tr key={rowIdx} className='text-center'>
                      <td>{rowData.name}</td>
                      <td>{rowData.type}</td>
                      <td>
                        {rowData.active ? (
                          <FaCheckCircle className='text-success' />
                        ) : (
                          <FaTimesCircle className='text-danger' />
                        )}
                      </td>
                      <td>
                        <div className='btn-group'>
                          <button
                            className='btn btn-primary btn-sm rounded-pill'
                            onClick={() => editHandler(rowData)}
                            data-bs-toggle='modal'
                            data-bs-target='#licenseModal'
                          >
                            <FaPenAlt />
                          </button>

                        </div>
                      </td>
                    </tr>
                  )
                  )
                )
              }
            </TableBody>
          </Table>
        </DatatableWrapper>) : ''}

    </div>
  )
}

export default ViewLicenses
